import React, { useEffect, useRef } from "react";

const formHtml = String.raw`<!-- Note : - You can modify the font style and form style to suit your website. - Code lines with comments Do not remove this code are required for the form to work properly, make sure that you do not remove these lines of code. - The Mandatory check script can modified as to suit your business needs. - It is important that you test the modified form before going live. - Do not remove captcha and other form elements that are necessary for the form to work. -->
<div id = 'crmWebToEntityForm' class = 'zcwf_lblLeft crmWebToEntityForm' style = 'background-color: white;color: black;max-width: 600px;'>
  <meta name = 'viewport' content = 'width=device-width, initial-scale=1.0'>
  <META HTTP-EQUIV = 'content-type' CONTENT = 'text/html;charset=UTF-8'>
  <style>
    .wf_customMessageBox{
      font-family: Arial, Helvetica, sans-serif;
      color: #132C14;
      background: #F5FAF5;
      box-shadow: 0 2px 6px 0 rgba(0,0,0,0.25);
      max-width: 90%;
      width: max-content;
      word-break: break-word;
      z-index: 11000;
      border-radius: 6px;
      border: 1px solid #A9D3AB;
      min-width: 100px;
      padding: 10px 15px;
      display: flex;
      align-items: center;
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .wf_customCircle{
      position: relative;
      background-color: #12AA67;
      border-radius: 100%;
      width: 20px;
      height: 20px;
      flex: none;
      margin-right: 7px;
    }
    .wf_customCheckMark{
      box-sizing: unset !important;
      position: absolute;
      transform: rotate(45deg)translate(-50%, -50%);
      left: 6px;
      top: 9px;
      height: 8px;
      width: 3px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
    }
    .wf_customClose{
      box-sizing: border-box;
      position: relative;
      width: 18px;
      height: 18px;
    }
    .wf_customClose::after, .wf_customClose::before{
      content: '';
      display: block;
      box-sizing: border-box;
      position: absolute;
      width: 12px;
      height: 1.5px;
      background: #616E88;
      transform: rotate(45deg);
      border-radius: 5px;
      top: 8px;
      left: 3px;
    }
    .wf_customClose::after{
      transform: rotate(-45deg)
    }
  </style>
  <div class = 'wf_customMessageBox' id = 'wf_splash' style = 'display:none'>
    <div class = 'wf_customCircle'>
      <div class = 'wf_customCheckMark'>
      </div>
    </div>
    <span id = 'wf_splash_info'>
    </span>
  </div>
  <form id = 'webform5266342000006078135' name = WebToLeads5266342000006078135 accept-charset = 'UTF-8'>
    <input type = 'text' style = 'display:none;' name = 'xnQsjsdp' value = 'd33a5dde84f6e6aa5275a80ea8165186531884011638a330a720a0a17bd83ec4'>
    </input>
    <input type = 'hidden' name = 'zc_gad' id = 'zc_gad' value = ''>
    </input>
    <input type = 'text' style = 'display:none;' name = 'xmIwtLD' value = 'f54233969badad631b59a099d4be60de16b22b93cbe7a769c5075d5e52d524f8b2a935aa1a2abc870a6de3bc4873b864'>
    </input>
    <input type = 'text' style = 'display:none;' name = 'actionType' value = 'TGVhZHM='>
    </input>
    <input type = 'text' style = 'display:none;' name = 'returnURL' value = 'null'>
    </input>
    <!-- Do not remove this code. -->
    <input type = 'text' style = 'display:none;' id = 'ldeskuid' name = 'ldeskuid'>
    </input>
    <input type = 'text' style = 'display:none;' id = 'LDTuvid' name = 'LDTuvid'>
    </input>
    <!-- Do not remove this code. -->
    <style>
      html,body{
        margin: 0px;
      }
      .formsubmit.zcwf_button{
        color: white !important;
        background: transparent linear-gradient(0deg, #0279FF 0%, #00A3F3 100%);
      }
      #crmWebToEntityForm.zcwf_lblLeft{
        width: 100%;
        padding: 25px;
        margin: 0 auto;
        box-sizing: border-box;
      }
      #crmWebToEntityForm.zcwf_lblLeft *{
        box-sizing: border-box;
      }
      #crmWebToEntityForm {
        text-align: left;
      }
      #crmWebToEntityForm *{
        direction: ltr;
      }
      .zcwf_lblLeft .zcwf_title{
        word-wrap: break-word;
        padding: 0px 6px 10px;
        font-weight: bold
      }
      .zcwf_lblLeft.cpT_primaryBtn:hover{
        background: linear-gradient(#02acff 0,#006be4 100%)no-repeat padding-box !important;
        box-shadow: 0 -2px 0 0 #0159b9 inset !important;
        border: 0 !important;
        color: #fff !important;
        outline: 0 !important;
      }
      .zcwf_lblLeft .zcwf_col_fld input[ type = text], input[ type = password], .zcwf_lblLeft .zcwf_col_fld textarea{
        width: 60%;
        border: 1px solid #c0c6cc !important;
        resize: vertical;
        border-radius: 2px;
        float: left;
      }
      .zcwf_lblLeft .zcwf_col_lab{
        width: 30%;
        word-break: break-word;
        padding: 0px 6px 0px;
        margin-right: 10px;
        margin-top: 5px;
        float: left;
        min-height: 1px;
      }
      .zcwf_lblLeft .zcwf_col_fld{
        float: left;
        width: 68%;
        padding: 0px 6px 0px;
        position: relative;
        margin-top: 5px;
      }
      .zcwf_lblLeft .zcwf_privacy {
        padding: 6px;
      }
      .zcwf_lblLeft .wfrm_fld_dpNn {
        display: none;
      }
      .dIB {
        display: inline-block;
      }
      .zcwf_lblLeft .zcwf_col_fld_slt{
        width: 60%;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 4px;
        font-size: 12px;
        float: left;
        resize: vertical;
        padding: 2px 5px;
      }
      .zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after{
        content: '';
        display: table;
        clear: both;
      }
      .zcwf_lblLeft .zcwf_col_help{
        float: left;
        margin-left: 7px;
        font-size: 12px;
        max-width: 35%;
        word-break: break-word;
      }
      .zcwf_lblLeft .zcwf_help_icon{
        cursor: pointer;
        width: 16px;
        height: 16px;
        display: inline-block;
        background: #fff;
        border: 1px solid #c0c6cc;
        color: #c1c1c1;
        text-align: center;
        font-size: 11px;
        line-height: 16px;
        font-weight: bold;
        border-radius: 50%;
      }
      .zcwf_lblLeft .zcwf_row {
        margin: 15px 0px;
      }
      .zcwf_lblLeft .formsubmit{
        margin-right: 5px;
        cursor: pointer;
        color: #313949;
        font-size: 12px;
      }
      .zcwf_lblLeft .zcwf_privacy_txt{
        width: 90%;
        color: rgb(0, 0, 0);
        font-size: 12px;
        font-family: Arial;
        display: inline-block;
        vertical-align: top;
        color: #313949;
        padding-top: 2px;
        margin-left: 6px;
      }
      .zcwf_lblLeft .zcwf_button{
        font-size: 12px;
        color: #313949;
        border: 1px solid #c0c6cc;
        padding: 3px 9px;
        border-radius: 4px;
        cursor: pointer;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .zcwf_lblLeft .zcwf_tooltip_over{
        position: relative;
      }
      .zcwf_lblLeft .zcwf_tooltip_ctn{
        position: absolute;
        background: #dedede;
        padding: 3px 6px;
        top: 3px;
        border-radius: 4px;
        word-break: break-word;
        min-width: 100px;
        max-width: 150px;
        color: #313949;
        z-index: 100;
      }
      .zcwf_lblLeft .zcwf_ckbox{
        float: left;
      }
      .zcwf_lblLeft .zcwf_file{
        width: 55%;
        box-sizing: border-box;
        float: left;
      }
      .cBoth:after{
        content: '';
        display: block;
        clear: both;
      }
      @media all and (max-width: 600px){
        .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld{
          width: auto;
          float: none !important;
        }
        .zcwf_lblLeft .zcwf_col_help {
          width: 40%;
        }
      }
    </style>
    <div class = 'zcwf_title' style = 'max-width: 600px;color: black; font-family:Arial;'>FALE COM A QUIMICAL</div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'First_Name'>Nome <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'First_Name' aria-required = 'true' aria-label = 'First Name' name = 'First Name' maxlength = '40'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Last_Name'>Sobrenome <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'Last_Name' aria-required = 'true' aria-label = 'Last Name' name = 'Last Name' maxlength = '80'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Email'>Email <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' ftype = 'email' autocomplete = 'false' id = 'Email' aria-required = 'true' aria-label = 'Email' name = 'Email' crmlabel = '' maxlength = '100'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Mobile'>WhatsApp <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'Mobile' aria-required = 'true' aria-label = 'Mobile' name = 'Mobile' maxlength = '30'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Company'>Empresa <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'Company' aria-required = 'true' aria-label = 'Company' name = 'Company' maxlength = '200'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Zip_Code'>CEP <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'Zip_Code' aria-required = 'true' aria-label = 'Zip Code' name = 'Zip Code' maxlength = '30'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'LEADCF5'>CNPJ/ CPF <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'LEADCF5' aria-required = 'true' aria-label = 'LEADCF5' name = 'LEADCF5' maxlength = '255'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Industry'>Segmento Industrial <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'Industry' onChange = 'addAriaSelected5266342000006078135()' aria-required = 'true' aria-label = 'Industry' name = 'Industry'>
          <option value = '-None-'>-None-</option>
          <option value = 'agricultura'>agricultura</option>
          <option value = 'biocombust&iacute;vel'>biocombust&iacute;vel</option>
          <option value = 'com&eacute;rcio&#x20;atacadista'>com&eacute;rcio atacadista</option>
          <option value = 'com&eacute;rcio&#x20;varejista'>com&eacute;rcio varejista</option>
          <option value = 'construtora'>construtora</option>
          <option value = 'constru&ccedil;&atilde;o&#x20;civil'>constru&ccedil;&atilde;o civil</option>
          <option value = 'curtume'>curtume</option>
          <option value = 'g&aacute;s'>g&aacute;s</option>
          <option value = 'metais&#x20;n&atilde;o-ferrosos'>metais n&atilde;o-ferrosos</option>
          <option value = 'minera&ccedil;&atilde;o'>minera&ccedil;&atilde;o</option>
          <option value = 'nutri&ccedil;&atilde;o&#x20;animal'>nutri&ccedil;&atilde;o animal</option>
          <option value = 'outros'>outros</option>
          <option value = 'pasta&#x20;e&#x20;papel'>pasta e papel</option>
          <option value = 'pelotiza&ccedil;&atilde;o'>pelotiza&ccedil;&atilde;o</option>
          <option value = 'petr&oacute;leo'>petr&oacute;leo</option>
          <option value = 'pol&iacute;meros'>pol&iacute;meros</option>
          <option value = 'produtor&#x20;rural'>produtor rural</option>
          <option value = 'produtos&#x20;refrat&aacute;rios'>produtos refrat&aacute;rios</option>
          <option value = 'qu&iacute;micos'>qu&iacute;micos</option>
          <option value = 'ra&ccedil;&atilde;o&#x20;para&#x20;nutri&ccedil;&atilde;o&#x20;animal'>ra&ccedil;&atilde;o para nutri&ccedil;&atilde;o animal</option>
          <option value = 'siderurgia'>siderurgia</option>
          <option value = 'tratamento&#x20;de&#x20;&aacute;gua'>tratamento de &aacute;gua</option>
          <option value = 'vidros'>vidros</option>
        </select>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'LEADCF15'>Produto Desejado <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'LEADCF15' aria-required = 'true' aria-label = 'LEADCF15' name = 'LEADCF15' maxlength = '255'>
        </input>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
        <label for = 'Description'>Mensagem <span style = 'color:red;'>*</span> </label>
      </div>
      <div class = 'zcwf_col_fld'>
        <textarea style = 'font-family: Arial, sans-serif;' aria-multiline = 'true' id = 'Description' aria-required = 'true' aria-label = 'Description' name = 'Description'>
        </textarea>
        <div class = 'zcwf_col_help'>
        </div>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' id = 'imageUploadField' style = 'font-size:12px; font-family: Arial;'>Arquivo de Cota&ccedil;&atilde;o</div>
      <div class = 'zcwf_col_fld'>
        <div class = 'cBoth'>
          <input type = 'file' class = 'zcwf_file' name = 'theFile' aria-labelledby = 'imageUploadField' id = 'theFile5266342000006078135' multiple />
          <div class = 'zcwf_col_help'>
          </div>
        </div>
        <p style = 'color:black;font-size:11px;padding-left:3px;'>File(s) size limit is 20MB.</p>
      </div>
    </div>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab' id = 'reCaptchaField' style = 'font-size:12px; font-family: Arial;'>Captcha</div>
      <div class = 'zcwf_col_fld'>
        <input type = 'text' id = 'captchaField5266342000006078135' aria-labelledby = 'reCaptchaField' maxlength = '10' name = 'enterdigest'/>
        <div id = 'captchaErr5266342000006078135' aria-live = 'polite' style = 'font-size:14px;color:red;padding-left:1px;visibility:hidden;position:absolute;padding-top:25px;'>
        </div>
      </div>
    </div>
    <!-- Do not remove this code. -->
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab'>
      </div>
      <div class = 'zcwf_col_fld'>
        <img id = 'imgid5266342000006078135' src = 'https://crm.zoho.com/crm/CaptchaServlet?formId=f54233969badad631b59a099d4be60de16b22b93cbe7a769c5075d5e52d524f8b2a935aa1a2abc870a6de3bc4873b864&grpid=d33a5dde84f6e6aa5275a80ea8165186531884011638a330a720a0a17bd83ec4' alt='CAPTCHA security verification image'>
        <a href = 'javascript:;' onclick = 'reloadImg5266342000006078135();'>Reload</a>
      </div>
      <div class = ''>
      </div>
    </div>
    <input type = 'text' type = 'hidden' style = 'display: none;' name = 'aG9uZXlwb3Q' value = ''/>
    <div class = 'zcwf_row'>
      <div class = 'zcwf_col_lab'>
      </div>
      <div class = 'zcwf_col_fld'>
        <input type = 'submit' id = 'formsubmit' role = 'button' class = 'formsubmit zcwf_button' value = 'Enviar' aria-label = 'Enviar' title = 'Enviar'>
        <input type = 'reset' class = 'zcwf_button' role = 'button' name = 'reset' value = 'Apagar' aria-label = 'Apagar' title = 'Apagar'>
      </div>
    </div>
  </form>
  <!-- Do not remove this code. -->
  <iframe name = 'captchaFrame' style = 'display:none;'>
  </iframe>
</div>`;

const scriptContent = String.raw`function addAriaSelected5266342000006078135 (){
  var optionElem = event.target;
  var items = optionElem.parentNode.parentNode.parentNode;
  var dropdowns = items.querySelectorAll(' .zcwf_col_fld_slt option');
  for(let i = 0; i < dropdowns.length ; i++)
  {
    dropdowns[i].removeAttribute('aria-selected');
  }
  optionElem.setAttribute('aria-selected','true');
}
function clearVar(element, isCheckbox = false) {
  var ele = document.getElementById('webform5266342000006078135').elements;
  for(var i = 0; i < ele.length; i++) {
    if(typeof(ele[i].type) !== 'undefined') {
      if (ele[i].type === 'checkbox') {
        if (ele[i].checked) {
          ele[i].click();
        }
      } else if (ele[i].type === 'radio') {
        ele[i].checked = false;
      } else if (ele[i].type === 'file') {
        ele[i].value = '';
      } else {
        ele[i].value = '';
      }
    }
  }
  if (!isCheckbox) {
    document.getElementById('captchaField5266342000006078135').focus();
    reloadImg5266342000006078135();
  }
}
function checkMandatory5266342000006078135() {
  var mandatoryFields = ['First Name', 'Last Name', 'Email', 'Mobile', 'Company', 'Zip Code', 'LEADCF5', 'Industry', 'LEADCF15', 'Description', 'enterdigest'];
  var isError = false;
  for(var i = 0; i < mandatoryFields.length; i++) {
    var field = document.querySelector('input[name="' + mandatoryFields[i] + '"], select[name="' + mandatoryFields[i] + '"], textarea[name="' + mandatoryFields[i] + '"]');
    if (field) {
      var val = field.value.trim();
      if(!val || (field.type === 'select-one' && val === '-None-')) {
        field.style.border = '2px solid red';
        field.focus();
        isError = true;
        break;
      } else {
        field.style.border = '';
      }
    }
  }
  return !isError;
}
function reloadImg5266342000006078135()
{
  var captchaImg = document.getElementById('imgid5266342000006078135');
  if( captchaImg !== null )
  {
    captchaImg.src= captchaImg.src.split('&d')[0] + '&d' + new Date().getTime();
  }
}

function validateEmailField5266342000006078135()
{
  var mailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;
  var email = document.querySelector('input[name="Email"]').value;
  if(!email.match(mailFormat))
  {
    window.alert('${('Enter valid email address')}');
    return false;
  }
  return true;
}

function tooltipShow5266342000006078135(el){
  var tooltip = el.nextElementSibling;
  var tooltipDisplay = tooltip.style.display;
  if(tooltipDisplay != 'block'){
    tooltip.style.display = 'block';
    tooltip.style.left = el.offsetLeft - 50 + 'px';
    tooltip.style.top = el.offsetTop + 30 + 'px';
  } else {
    tooltip.style.display = 'none';
  }
}

function submitForm5266342000006078135() {
  if (checkMandatory5266342000006078135() && validateEmailField5266342000006078135()) {
    document.getElementById('webform5266342000006078135').submit();
  }
}

window.addEventListener('DOMContentLoaded', function() {
  document.getElementById('webform5266342000006078135').addEventListener('submit', function(e) {
    e.preventDefault();
    if (checkMandatory5266342000006078135() && validateEmailField5266342000006078135()) {
      this.submit();
    }
  });
});`;

const ZohoContactForm: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Insert the HTML
    containerRef.current.innerHTML = formHtml;

    // Execute the script
    const script = document.createElement('script');
    script.text = scriptContent;
    containerRef.current.appendChild(script);

    // Clean up on unmount
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} />;
};

export default ZohoContactForm;